<template>
    <span class="text-danger">*</span>
</template>

<script>
export default {
    name: "RequiredField"
}
</script>

<style scoped>

</style>
